import styled from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'

export const StyledGamesListWrapper = styled.div`
  display: grid;
  gap: ${(props) => (props.hideText ? '1.5em 1em' : '0.75em')};
  ${themeMedia.maxTablet`
${(props) => (props.hideText ? 'gap: 0.56em;' : '')}
`}

  grid-template-columns: repeat(${(props) => props.$columns}, minmax(0, 1fr));
`

export const StyledListAndButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  button {
    margin: 1em auto;
  }
`

export const StyledEmptyGamesListWrapper = styled.div`
  color: ${themeStyles.colors.white.main};
  text-align: center;
  padding: 2em 0 4em;
`

export const StyledGameTileWrapper = styled.div`
  border-radius: 8px;
  background: transparent;
  border: 2px solid transparent;
  transition: 0.2s border;

  &:hover {
    border: 2px solid ${themeStyles.colors.white.main}4D;
  }
`

export const StyledFallbackOuterWrapper = styled.div`
  overflow-x: none;
  display: flex;
  flex-direction: column;
  gap: 0.75em;
`

export const StyledFallbackInnerWrapper = styled.div`
  display: grid;
  gap: 0.75em;

  grid-template-columns: repeat(6, minmax(0, 1fr));
  ${themeMedia.maxTablet`
    grid-template-columns: repeat(3, minmax(0, 1fr));
  `}

  div {
    display: flex;
    flex-direction: column;
    gap: 1px;
  }
`
